import { POOL_PATTERN } from "@seagames/contracts";
import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { type StandingsSearch, StandingsView } from "../../components/standings/standings-view";
import { STANDINGS_TABS } from "../../components/standings/tabs";

/**
 * Phase standings, advance and fill-slots, and the event's bracket. The
 * filters and the view are URL search params, so a table can be shared or
 * reloaded as it is; a bad value is dropped, never an error page. The top
 * bar's crumbs (Meets › Sport › Event › Phase) are the way back.
 */
const standingsSearch = z.object({
	pool: z.string().trim().toUpperCase().regex(POOL_PATTERN).optional().catch(undefined),
	round: z.coerce.number().int().min(1).max(32_767).optional().catch(undefined),
	view: z.enum(STANDINGS_TABS).optional().catch(undefined),
});

export const Route = createFileRoute("/_app/phases/$phaseId")({
	validateSearch: (raw): StandingsSearch => standingsSearch.parse(raw),
	component: StandingsPage,
});

function StandingsPage() {
	const { phaseId } = Route.useParams();
	const { readOnly } = Route.useRouteContext();
	const search = Route.useSearch();
	const navigate = Route.useNavigate();
	return (
		<StandingsView
			// A new phase starts clean: its own filters, its own dialogs.
			key={phaseId}
			phaseId={phaseId}
			search={search}
			readOnly={readOnly}
			onSearch={(next) => navigate({ search: next })}
		/>
	);
}
